import { call, put, takeLatest } from 'redux-saga/effects'

import { postPlan, putPlan, deletePlan } from '@galo-monitor/services/apis/galoMonitorApi/resources/plan'

import { PlanActions, PlanTypes } from './duckPlan'

function* savePlan({ plan, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(plan.id ? putPlan : postPlan , plan)
    yield call(onSuccess)
  } catch (err) {
    yield put(PlanActions.planError(err.message))
    yield call(onError, err)
  }
}

function* removePlan({ plan, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deletePlan, plan)
    yield call(onSuccess)
  } catch (err) {
    yield put(PlanActions.planError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(PlanTypes.SAVE_PLAN, savePlan),
  takeLatest(PlanTypes.REMOVE_PLAN, removePlan)
]
